export type CraftRow = {
	CraftId: number | null;
	CraftName: string;
	Code: string | null;
	Color: string;
	WorkOrderCount?: number;
	TemplateCount?: number;
};

export type ModalMode = "new" | "edit" | "delete" | "";

// Two rows of 12. The first is ColorBrewer "Paired", the family the first crafts were coloured
// from, with its yellow and light pink swapped for a blue grey and a teal. The second adds darker
// tones, where the white badge letter reads best.
export const CRAFT_COLORS = [
	"#a6cee3",
	"#1f78b4",
	"#b2df8a",
	"#33a02c",
	"#00796b",
	"#e31a1c",
	"#fdbf6f",
	"#ff7f00",
	"#cab2d6",
	"#6a3d9a",
	"#b15928",
	"#455a64",
	"#283593",
	"#0288d1",
	"#00838f",
	"#1b5e20",
	"#827717",
	"#e65100",
	"#5d4037",
	"#c2185b",
	"#880e4f",
	"#9c27b0",
	"#4527a0",
	"#616161",
];

export const CRAFT_INITIAL_VALUES: CraftRow = {
	CraftId: null,
	CraftName: "",
	Code: "",
	Color: "",
};

const sameColor = (a?: string | null, b?: string | null) =>
	(a ?? "").trim().toLowerCase() === (b ?? "").trim().toLowerCase();

// The craft, other than the one being edited, that already shows this colour
export const craftUsingColor = (
	crafts: CraftRow[],
	color: string,
	craftId: number | null,
) => crafts.find((c) => c.CraftId !== craftId && sameColor(c.Color, color));

// New crafts start on the first palette colour nobody uses yet
export const firstFreeColor = (crafts: CraftRow[]) =>
	CRAFT_COLORS.find((color) => !craftUsingColor(crafts, color, null)) ?? "";
